(() => {
  const translations = {
    [Shopify.locale]: rebuyLocale,
  };

  updateSmartCartLanguage = () => {
    const locale = Shopify?.locale;
    const translation = translations[locale]?.smart_cart;
    const subscriptionTranslations =
      translations[locale]?.cart_switch_to_subscription;
    const tierPrgoressBarTranslations = translations[locale]?.tier_progress_bar;
    const components = Rebuy.SmartCart.settings.components;
    const buyMoreSaveMore = Rebuy.SmartCart.settings.buy_more_save_more;
    const emptyCart = Rebuy.SmartCart.settings.empty_cart_markup;
    const switchToSubscription =
      Rebuy.SmartCart.settings.switch_to_subscription;
    const storefrontHelper = new ShopifyStorefrontHelper();

    if (locale && translation && components) {
      components.forEach((component) => {
        switch (component.type) {
          case "checkout": {
            const checkoutTranslation = {
              checkout_label: translation.checkout_label,
              view_cart_label: translation.view_cart_label,
              checking_out_label: translation.checking_out_label,
              view_cart_working_label: translation.view_cart_working_label,
              continue_shopping_label: translation.continue_shopping_label,
              terms_and_conditions_label:
                translation.terms_and_conditions_label,
            };
            Object.assign(component.settings.language, checkoutTranslation);
            break;
          }
          case "cart_subtotal": {
            const cartSubtotalTranslation = {
              subtotal_plural_text: translation.subtotal_plural_text,
              subtotal_singular_text: translation.subtotal_singular_text,
            };
            Object.assign(component.settings, cartSubtotalTranslation);
            break;
          }
          case "tiered_progress_bar": {
            const progressBarTranslation = {
              free_shipping_reached:
                tierPrgoressBarTranslations.free_shipping_reached,
              free_shipping_remaining:
                tierPrgoressBarTranslations.free_shipping_remaining,
              product_amount_reached_label_text:
                tierPrgoressBarTranslations.product_amount_reached_label_text,
              product_amount_remaining_label_text:
                tierPrgoressBarTranslations.product_amount_remaining_label_text,
              discount_amount_remaining_label_text:
                tierPrgoressBarTranslations.discount_amount_remaining_label_text,
              discount_amount_reached_label_text:
                tierPrgoressBarTranslations.discount_amount_reached_label_text,
            };
            if (component.settings.bars) {
              component.settings.bars.forEach((bar) => {
                Object.assign(bar.language, progressBarTranslation);
                bar.earnedProducts?.forEach((product) => {
                  storefrontHelper.updateProductJSON(product);
                });
                bar.tiers.forEach((tier, index) => {
                  if (tier.type !== "shipping") {
                    Object.assign(tier, progressBarTranslation);
                    if (tier.type === "product") {
                      storefrontHelper.updateProductJSON(tier.products[0]);
                    }
                  }

                  if (tier.type === "shipping") {
                    document.querySelectorAll(
                      ".rebuy-cart__progress-step-label"
                    )[index].innerText =
                      tierPrgoressBarTranslations.free_shipping;
                  }
                });
              });
            }
            break;
          }
          case "title_bar": {
            const titleBarTranslation = {
              title: translation.cart_title,
            };
            Object.assign(component.settings, titleBarTranslation);
            break;
          }
          case "login": {
            const loginTranslation = {
              title: translation.login_title,
            };
            Object.assign(component.settings.language, loginTranslation);
            break;
          }
          case "discount_code": {
            const discountCodeTranslation = {
              discount_code_label: translation.discount_code_label,
              discount_button_label: translation.discount_button_label,
              discount_invalid_message: translation.discount_invalid_message,
            };
            Object.assign(component.settings.language, discountCodeTranslation);
            break;
          }
          case "notes": {
            const notesTranslation = {
              notes_label: translation.notes_label,
              notes_placeholder: translation.notes_placeholder,
              notes_remaining_characters:
                translation.notes_remaining_characters,
            };
            Object.assign(component.settings.language, notesTranslation);
            break;
          }
        }
      });

      // Handle 'buy_more_save_more' settings
      if (buyMoreSaveMore) {
        const bmsmTranslation = {
          bmsm_discount_message: translation.bmsm_discount_message,
          bmsm_discount_success: translation.bmsm_discount_success,
        };
        Object.assign(buyMoreSaveMore.language, bmsmTranslation);
      }

      // Handle 'empty cart' settings
      if (emptyCart) {
        const emptyCartTranslation = {
          empty_cart_markup: translation.empty_cart_markup,
        };
        Object.assign(Rebuy.SmartCart.settings, emptyCartTranslation);
      }

      if (switchToSubscription) {
        const subscriptionTranslation = {
          downgrading_label: subscriptionTranslations.downgrading_label,
          onetime_option_group_label:
            subscriptionTranslations.onetime_option_group_label,
          onetime_option_label: subscriptionTranslations.onetime_option_label,
          subscription_option_group_label:
            subscriptionTranslations.subscription_option_group_label,
          upgrade_to_subscription_label:
            subscriptionTranslations.upgrade_to_subscription_label,
          upgrade_to_subscription_without_discount_label:
            subscriptionTranslations.upgrade_to_subscription_without_discount_label,
          upgrading_label: subscriptionTranslations.upgrading_label,
        };
        Object.assign(switchToSubscription.language, subscriptionTranslation);
      }
    }
  };

  updateWidgetLanguage = (widget) => {
    const locale = Shopify?.locale;
    const widgetTranslation = translations[locale]?.[widget.id];
    const globalTranslation = translations[locale]?.widget;
    if (locale && widgetTranslation) {
      Object.assign(widget.data.settings.language, widgetTranslation);
      widget.compileConfig();
    } else if (locale && globalTranslation) {
      Object.assign(widget.data.settings.language, globalTranslation);
      widget.compileConfig();
    }
  };

  updateTierLanguage = () => {
    const locale = Shopify?.locale;
    const giftTitle = document.querySelector(
      ".rebuy-cart__progress-gifts-title"
    );
    const variantPromt = document.querySelectorAll(
      ".rebuy-cart__progress-gift-variant-select-prompt"
    );
    const firstOption = document.querySelectorAll(
      '.rebuy-cart__progress-gift-variant-select option[value=""]'
    );

    if (giftTitle) {
      giftTitle.textContent = translations[locale]?.smart_cart.gift_title;
    }

    if (variantPromt) {
      variantPromt.forEach(
        (prompt) =>
          (prompt.textContent = translations[locale]?.smart_cart.select_gift)
      );
    }

    if (firstOption) {
      firstOption.forEach(
        (prompt) =>
          (prompt.textContent = translations[locale]?.smart_cart.select_gift)
      );
    }
  };

  updateAnnouncementBar = () => {
    const locale = Shopify?.locale;
    const announcementTranslations =
      translations[locale]?.announcement_bar?.bars;
    const components = Rebuy.SmartCart.settings.components;
    if (announcementTranslations) {
      const announcementBars = components.filter(
        (c) => c.type === "announcement_bar"
      );
      announcementBars.forEach((bar, index) => {
        Object.assign(bar.settings, announcementTranslations[index]);
      });
    }
  };

  // Update Smart Cart with locale translations
  document.addEventListener("rebuy:smartcart.ready", () => {
    updateSmartCartLanguage();
    updateAnnouncementBar();
  });

  // Update widgets with locale translations
  document.addEventListener("rebuy.ready", (event) => {
    const widget = event.detail.widget;
    updateWidgetLanguage(widget);
  });

  // Update free gifts text
  document.addEventListener("rebuy:cart.change", () => {
    setTimeout(() => {
      updateTierLanguage();
      updateSmartCartLanguage();
      updateAnnouncementBar();
    }, 0);
  });

  // update product JSON every time products are loaded or changed
  document.addEventListener("rebuy.productsChange", (e) => {
    const widget = e.detail.widget;
    const storefrontHelper = new ShopifyStorefrontHelper();

    // loop over products in the widget and enrich product json
    widget.data.products.forEach((product) =>
      storefrontHelper.updateProductJSON(product)
    );
  });
})();
